"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const utils_1 = require("./utils");
const DEFAULT_CONFIG = {
    containerId: 'babka-login-btn',
    customization: {
        allowFullscreen: false,
        theme: 'default',
        size: 'default'
    },
    locale: 'en',
    widgetUrl: 'https://accounts.babka.com'
};
class Button {
    constructor(config) {
        this.config = Object.assign(Object.assign({}, DEFAULT_CONFIG), config);
        const { containerId, customization, locale, widgetUrl, client_id, redirect_uri, state, scope, audience, popup } = this.config;
        const mountNode = document.getElementById(containerId);
        if (mountNode) {
            try {
                let src = widgetUrl + '/?locale=' + locale;
                if (client_id)
                    src += `&client_id=${client_id}`;
                if (redirect_uri)
                    src += `&redirect_uri=${encodeURIComponent(redirect_uri)}`;
                if (state)
                    src += `&state=${state}`;
                if (scope)
                    src += `&scope=${scope.join(' ')}`;
                if (audience)
                    src += `&audience=${audience.join(' ')}`;
                if (popup)
                    src += `&popup=${popup}`;
                const frame = document.createElement('iframe');
                frame.src = src;
                frame.width = utils_1.getWidth(customization.size);
                frame.height = utils_1.getHeight(customization.size);
                frame.sandbox.add('allow-same-origin');
                frame.sandbox.add('allow-scripts');
                frame.sandbox.add('allow-top-navigation');
                frame.sandbox.add('allow-popups');
                frame.frameBorder = '0';
                frame.name = 'example';
                frame.allowFullscreen = !!customization.allowFullscreen;
                frame.onload = () => {
                    // window.frames.example.postMessage(props, '*');
                };
                this.iframe = frame;
                mountNode.append(frame);
            }
            catch (e) {
                console.error(e);
            }
        }
        // если на странице не существует HTML элемента с указанным идентификатором
        // выводим сообщение: блок с идентификатором id="id" отсутствует
        else {
            console.error('The specified block id="' + containerId + '" is missing');
        }
    }
}
exports.Button = Button;
//# sourceMappingURL=index.js.map